export const apiHost = process.env.VUE_APP_API_HOST;
export const googleApiKey = process.env.VUE_APP_GOOGLE_API_KEY;
export const midtransURL = process.env.VUE_APP_MIDTRANS_URL;
export const midtransKey = process.env.VUE_APP_MIDTRANS_KEY;
export const googleAnalyticsKey = process.env.VUE_APP_GOOGLE_ANALYTICS_KEY;